import React, { useState } from 'react';
import { func, string, bool } from 'prop-types';
import classnames from 'classnames';
import UIIcon from 'components/UI/Icon/Icon';
import IconButton from 'components/UI/IconButton/IconButton';
import useDebouncedInput from 'utils/useDebouncedInput';

import './SearchInput.scss';

const cbn = 'form-search-input';

function FormSearchInput({
  disabled = false,
  hasOffset = false,
  name = null,
  onChange: parentOnChange,
  onFocus = () => {},
  placeholder = 'Search',
  value: parentValue = '',
  type = 'text',
  cbn: parentCbn = '',
  ...props
}: {
  disabled?: boolean;
  hasOffset?: boolean;
  name?: string;
  onChange?: (arg0?: React.ChangeEvent<HTMLInputElement>) => void;
  onFocus?: (arg0?: React.FocusEvent<HTMLInputElement>) => void;
  placeholder?: string;
  value?: string;
  type?: string;
  cbn?: string;
}) {
  const [isFocused, setFocus] = useState(false);
  const [value, onChange] = useDebouncedInput(parentValue, parentOnChange);

  return (
    <div
      className={classnames(cbn, parentCbn, {
        [`${cbn}--is-focused`]: isFocused,
        [`${cbn}--is-disabled`]: disabled,
        [`${cbn}--has-offset`]: hasOffset,
      })}
    >
      <input
        type={type}
        name={name}
        className={`${cbn}__input`}
        value={value || ''}
        onFocus={(e) => {
          setFocus(true);
          onFocus(e);
        }}
        onBlur={() => setFocus(false)}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        autoComplete="off"
        {...props}
      />
      <div
        className={classnames(`${cbn}__icon`, {
          [`${cbn}__icon--close`]: value,
        })}
      >
        {!value ? (
          <UIIcon type="search" />
        ) : (
          <IconButton
            icon="close"
            size="small"
            // @ts-ignore
            onClick={() => parentOnChange('')}
          />
        )}
      </div>
    </div>
  );
}

FormSearchInput.propTypes = {
  disabled: bool,
  hasOffset: bool,
  name: string,
  onChange: func.isRequired,
  onFocus: func,
  placeholder: string,
  value: string,
  type: string,
  cbn: string,
};

export default FormSearchInput;
